export default __webpack_public_path__ + "static/media/scritta.9a6b2994.svg";